function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.563 4.75)"
}, React.createElement("rect", {
  width: 9.5,
  height: 1.781,
  rx: 0.75,
  transform: "translate(2.375)",
  fill: "#597ef7"
}), React.createElement("rect", {
  width: 1.781,
  height: 1.781,
  rx: 0.75,
  fill: "#597ef7"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.563 12.469)"
}, React.createElement("rect", {
  width: 9.5,
  height: 1.781,
  rx: 0.75,
  transform: "translate(2.375)",
  fill: "#597ef7"
}), React.createElement("rect", {
  width: 1.781,
  height: 1.781,
  rx: 0.75,
  fill: "#597ef7"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(3.563 8.609)"
}, React.createElement("rect", {
  width: 9.5,
  height: 1.781,
  rx: 0.75,
  transform: "translate(2.375)",
  fill: "#597ef7"
}), React.createElement("rect", {
  width: 1.781,
  height: 1.781,
  rx: 0.75,
  fill: "#597ef7"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.625,1.188a1.189,1.189,0,0,1,1.188,1.188v14.25a1.189,1.189,0,0,1-1.187,1.188H2.375a1.189,1.189,0,0,1-1.187-1.187V2.375A1.189,1.189,0,0,1,2.375,1.188h14.25m0-1.187H2.375A2.374,2.374,0,0,0,0,2.375v14.25A2.374,2.374,0,0,0,2.375,19h14.25A2.374,2.374,0,0,0,19,16.625V2.375A2.374,2.374,0,0,0,16.625,0Z",
  fill: "#597ef7"
});

var SvgTotalpackage = function SvgTotalpackage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTotalpackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/totalpackage.c0d81a84.svg";
export { ForwardRef as ReactComponent };